import { Section } from 'components/section'
import { Heading } from 'components/heading'

import { FaqSearch } from '../search'
import classes from './faq-search-section.module.css'

export const FaqSearchSection = () => {
  return (
    <div className={classes.mainSectionContainer}>
      <Section className={classes.mainSection}>
        <Heading theme="h6" component="h2" className={classes.subtitle}>
          frequently asked questions
        </Heading>
        <Heading className={classes.mainTitle} theme="h1">
          How can we help?
        </Heading>
        <FaqSearch />
      </Section>
    </div>
  )
}
